import { render, staticRenderFns } from "./XeroPage.vue?vue&type=template&id=6d2c4f4d&scoped=true&"
import script from "./XeroPage.vue?vue&type=script&lang=js&"
export * from "./XeroPage.vue?vue&type=script&lang=js&"
import style0 from "./XeroPage.vue?vue&type=style&index=0&id=6d2c4f4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c4f4d",
  null
  
)

export default component.exports